import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../config/authAxios";

const initialState = {
  status: null,
  loading: false,
  data: [],
  totalDocs: 0,
  totalPages: 0,
  currentPage: 0,
  error: "",
  message: "",
};

export const getAllUserOfferAttemptsAction = createAsyncThunk(
  "get-all-user-offer-attempts",
  async (data, { rejectWithValue }) => {
    try {
      const { page, pageSize, search, status, offer_id, partner_id, user_id } = data;
      const res = await axios.get(`/admins/api/getAllUserOfferAttempts`, {
        params: {
          page: page,
          limit: pageSize,
          search: search || "",
          status: status !== undefined ? status : "",
          offer_id: offer_id || "",
          partner_id: partner_id || "",
          user_id: user_id || ""
        }
      });
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAllUserOfferAttemptsSlice = createSlice({
  name: "get-all-user-offer-attempts",
  initialState,
  reducers: {
    resetGetAllUserOfferAttemptsState: (state) => {
      state.status = null;
      state.loading = false;
      state.data = [];
      state.totalDocs = 0;
      state.totalPages = 0;
      state.currentPage = 0;
      state.error = "";
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllUserOfferAttemptsAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllUserOfferAttemptsAction.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload?.data;
      state.totalDocs = action?.payload?.totalDocs;
      state.totalPages = action?.payload?.totalPages;
      state.currentPage = action?.payload?.currentPage;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
    builder.addCase(getAllUserOfferAttemptsAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
  },
});

export const { resetGetAllUserOfferAttemptsState } = getAllUserOfferAttemptsSlice.actions;
export const getAllUserOfferAttemptsReducer = getAllUserOfferAttemptsSlice.reducer;
